import { RuleOverrideType } from '$constants'
import dayjs, { Dayjs } from 'dayjs'

export interface ClockinRuleOverride {
  id: string
  clockinId: string
  ruleId: string
  type: RuleOverrideType
  addedAt: Dayjs
  deletedAt: Dayjs | null
  appliedFrom: Dayjs
  appliedTo: Dayjs
  newOverride: boolean
}

// Functions to apply transformations to ClockinRuleDetail object
export const transformClockinRuleOverrideOnGet = (
  clockinRuleOverride: ClockinRuleOverride
): ClockinRuleOverride => {
  return {
    ...clockinRuleOverride,
    addedAt: dayjs(clockinRuleOverride.addedAt),
    deletedAt: clockinRuleOverride.deletedAt
      ? dayjs(clockinRuleOverride.deletedAt)
      : null,
    appliedFrom: dayjs(clockinRuleOverride.appliedFrom),
    appliedTo: dayjs(clockinRuleOverride.appliedTo),
  }
}

export const transformClockinRuleOverrideOnSave = (
  clockinRuleOverride: ClockinRuleOverride
): ClockinRuleOverride => {
  return {
    ...clockinRuleOverride,
    addedAt: clockinRuleOverride.addedAt.utc(),
    appliedFrom: clockinRuleOverride.appliedFrom.utc(),
    appliedTo: clockinRuleOverride.appliedTo.utc(),
  }
}
